export const loginEndpointUrl = '/api/auth/login';
export const refreshTokensEndpointUrl = '/api/auth/refresh';
export const userDataEndpointUrl = '/api/user';
